<template>
    <b-container id="Offices" class="Offices">
        <div id="triggerOffice1"></div>
        <b-row>
            <b-col cols="12">
                <h2 class="tac">{{$t('offices.title')}}</h2>
            </b-col>
        </b-row>
        <b-row>
            <div id="triggerOffice2"></div>
            <b-col v-for="(office, i) in myJson.offices" :key="i" class="officesFlex wrapper" sm="12" md="4">
                <Office 
                        :index="i"
                        :anim="'animOffice' + i"
                        :alt="$t('offices.offices['+i+'].city') + ' image'"
                        :img="$t('offices.offices['+i+'].img')"
                        :city="$t('offices.offices['+i+'].city')"
                        :adresse="$t('offices.offices['+i+'].adresse')"/>
            </b-col>
        </b-row>
        <!-- <b-row>
            <b-col cols="12">
                <iframe :src="myJson.offices[showMap].iframe" width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
            </b-col>
        </b-row> -->
    </b-container>
</template> 

<script>
import Office from "./Office.vue"
import json from '@/locales/en.json'

export default {
    name:'Offices',
    components: {
        Office 
    },
    data: function () {
        return {
            showMap: 0,
            myJson: json.offices
        }
    },
    methods: {

    }
}
</script> 

<style scoped lang="scss">
@import '@/assets/style/offices.scss';
</style>